module.exports = __webpack_public_path__ + "files/f3599e7798795806920849ab9429a6e7.png";